import { useEffect, useState } from 'react';
import { MapPin, Eye } from 'lucide-react';
import { api } from '../../lib/api';
import type { StaffInfo } from '../../types';
import { Spinner, EmptyState, Avatar } from '../../components/ui';
import StaffDetailModal from '../../components/StaffDetailModal';

export default function Staff() {
  const [staff, setStaff] = useState<StaffInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState<StaffInfo | null>(null);

  useEffect(() => {
    api
      .get<StaffInfo[]>('/auth/users?role=staff')
      .then(setStaff)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner label="Loading staff..." />;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Staff</h1>

      {staff.length === 0 ? (
        <EmptyState message="No staff members found." />
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {staff.map((st) => (
            <button
              key={st.id}
              onClick={() => setDetail(st)}
              className="bg-white p-6 rounded-lg shadow-lg text-left hover:shadow-xl transition cursor-pointer"
            >
              <div className="flex items-center space-x-4">
                <Avatar src={st.image_url} name={st.name} className="w-16 h-16" />
                <div>
                  <h3 className="font-semibold">{st.name}</h3>
                  <p className="text-sm text-gray-500 capitalize">{st.role_title || st.role}</p>
                </div>
              </div>
              <div className="mt-4 space-y-1 text-sm text-gray-500">
                <p>{st.email}</p>
                {st.phone && <p>{st.phone}</p>}
                {st.estate && (
                  <p className="flex items-center">
                    <MapPin className="h-4 w-4 mr-1 text-gray-400" /> {st.estate}
                  </p>
                )}
              </div>
              <div className="mt-4 flex items-center gap-1.5 text-primary text-sm font-medium">
                <Eye className="h-4 w-4" /> View full information
              </div>
            </button>
          ))}
        </div>
      )}

      <StaffDetailModal staff={detail} onClose={() => setDetail(null)} />
    </div>
  );
}
